import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { SxCookieService } from '@services';
import { CookieAttributes } from 'es-cookie';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    standalone: false
})
export class CookieConsentComponent implements OnInit, OnChanges {
  
  @Input()
  approved: boolean;

  showConsent = false;

  constructor( private changeDetectorRef: ChangeDetectorRef,  private sxCookieService: SxCookieService) { }

  ngOnInit(): void {

    if (localStorage.getItem('CONSENT')) {
      this.approved = localStorage.getItem('CONSENT') === 'YES';
    }

    // Small delay so content is loaded
    setTimeout(() => {
      this.showConsent = true;
      this.changeDetectorRef.detectChanges();
    }, 1000);
  }

  ngOnChanges(): void {
    if (localStorage.getItem('CONSENT')) {
      this.approved = localStorage.getItem('CONSENT') === 'YES';
   }
 }

  onApprove() {
    localStorage.setItem('CONSENT', 'YES');
    this.approved = localStorage.getItem('CONSENT') === 'YES';
    localStorage.removeItem('SHOW_CONSENT');
    this.changeDetectorRef.detectChanges();
  }
}
